/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.$ = window.jQuery = require('jquery');
require('../bootstrap');
require('../plugins');


require('jquery-migrate');
require('slick-carousel');
//require('datatables.net');
// window.Vue = require('vue');


function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function deleteCookie(name) {
  setCookie(name, '', -1);
}

$('.menu-icon').on('click', function () {
  $('#sidenav').css('left', '0');

  $(document).mouseup(function (e) {
    var container = $("#sidenav");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.css({'left': '-95%', 'transition': 'ease-in-out left 1s'});
    }
  });
});

$('#sidenav .closebtn').on('click', function () {
  $('#sidenav').css('left', '-95%');
});

var prevScrollpos = window.pageYOffset;

if (prevScrollpos === 0) {
  $('#open-submenu, #arrow-light-down, #close-submenu, #arrow-light-up, #second-nav').css('height', 0);
  $('#second-nav').css('visibility', 'hidden');
}

window.onscroll = function () {
  var currentScrollPos = window.pageYOffset;
  if ($(document).scrollTop() > 150) {
    if (prevScrollpos > currentScrollPos) {
      $('#full-top-menu').css('top', 0);
      $('#open-submenu, #arrow-light-down, #close-submenu, #arrow-light-up, #second-nav').css('height', 0);

      $('#second-nav').css('visibility', 'hidden');
    } else {
      // $('#full-top-menu').css('top', '-70px');
      $('#open-submenu').css('height', '40px');
      $('#arrow-light-down').css('height', '30px');
      $('#close-submenu, #arrow-light-up, #second-nav').css('height', 0);

      $('#second-nav').css('visibility', 'hidden');
      if ($(this).outerWidth() <= 767.98) {
        $('#full-top-menu').css('top', '-140px');
      } else {
        $('#full-top-menu').css('top', '-70px');
      }
    }
    prevScrollpos = currentScrollPos;
  }

}

$('#open-submenu').on('click', function () {
  $('#open-submenu, #arrow-light-down').css('height', 0);
  $('#close-submenu, #arrow-light-up').css('height', '30px');
  if ($(document).outerWidth() <= 767.98) {
    $('#second-nav').animate({'height': '140px'}, 'fast');
  } else {
    $('#second-nav').animate({'height': '70px'}, 'fast');
  }
  $('#second-nav').css('visibility', 'visible');
});

$('#close-submenu').on('click', function () {
  $('#close-submenu, #arrow-light-up').css('height', 0);
  $('#open-submenu, #arrow-light-down').css('height', '30px');

  $('#second-nav').css({'height': '0', 'visibility': 'hidden'});
});

$('#full-top-menu .search-icon').on('click', function () {
  $('.search-box').css({'height': '350px', 'visibility': 'visible'});
  $('.search-content').css('display', 'block');
  $('.search-input').focus();
});

$('#closeSearch .closebtn').on('click', function () {
  $('.search-box').animate({height: '0', display: 'none'}, 'fast');
  $('.search-content').css('display', 'none');
});

$('.phone-icon').on('click', function () {
  $('.phone-box, .phone-anchor').css('display', 'block');
  $(document).mouseup(function (e) {
    var container = $(".phone-box");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.css({'display': 'none', 'transition': 'ease-in-out all 0.3s'});
      $('.phone-anchor').css('display', 'none');
    }
  });
});

$(function () {
  var pagePositon = 0,
    sectionsSeclector = 'section',
    $scrollItems = $(sectionsSeclector),
    offsetTolorence = 30,
    pageMaxPosition = $scrollItems.length - 1;

  //Map the sections:
  $scrollItems.each(function (index, ele) {
    $(ele).attr("debog", index).data("pos", index);
  });

  // Bind to scroll
  $(window).bind('scroll', upPos);

  //Move on click:
  $('#next-section').click(function (e) {
    if ($(this).hasClass('next') && pagePositon + 1 <= pageMaxPosition) {
      pagePositon++;
      $('html, body').stop().animate({
        scrollTop: $scrollItems.eq(pagePositon).offset().top
      }, 700);
    }
  });

  //Update position func:
  function upPos() {
    var fromTop = $(this).scrollTop();
    var $cur = null;
    $scrollItems.each(function (index, ele) {
      if ($(ele).offset().top < fromTop + offsetTolorence) $cur = $(ele);
    });
    if ($cur != null && pagePositon != $cur.data('pos')) {
      pagePositon = $cur.data('pos');
    }
  }
});

$('.see-grid').on('click', function () {
  deleteCookie('listGridProduct');
  $(".gridProduct").removeClass("listGridProduct");
});

$('.see-list').on('click', function () {
  setCookie('listGridProduct', 'listGridProduct', 93);
  $(".gridProduct").addClass("listGridProduct");
});

$('.open-menu').on('click', function () {
  $(".menuProduct").removeClass('d-none');
  $(document).mouseup(function (e) {
    var container = $(".menuProduct");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.css({'display': 'none', 'transition': 'ease-in-out all 0.3s'});
    }
  });
});

$(".open-lateral-menu .filters").on('click', function () {

  $(".product-detail-container .nav-side-menu").css('display', 'block');
  $(".listOfProducts .nav-side-menu").css('display', 'block');
  $(".product-detail-container .open-lateral-menu").css('display', 'none');
  $(".listOfProducts .open-lateral-menu").css('display', 'none');
});

$(".nav-side-menu .head-menu .filters").on('click', function () {

  $(".product-detail-container .nav-side-menu").css('display', 'none');
  $(".listOfProducts .nav-side-menu").css('display', 'none');
  $(".product-detail-container .open-lateral-menu").css('display', 'block');
  $(".listOfProducts .open-lateral-menu").css('display', 'block');
});

window.modalFE = function (idModal, idDivToMove, elemBtnOpen) {
  const _self = this;
  $('#' + elemBtnOpen).on('click', function () {

    _self.popup = $('#' + idModal);
    _self.popup.modal('show');

    _self.popup.on('click', function () {
      _self.popup.modal('hide');
    });
    _self.popup.on('click', '.modal-dialog', function (e) {
      e.stopPropagation();
    });

    _self.popup.on('click', ' .close', function (e) {
      e.stopPropagation();
      _self.popup.modal('hide');
    });
  });
}

window.filtersListProductCategories = [];

$('#menu-content li').on('click', function () {
  //aria-expanded="true"
  if ($(this).find('.arrow').is('.arrowDown') || $(this).attr('aria-expanded') == 'true') {
    $(this).find('.arrow').removeClass('arrowDown');

    const index = window.filtersListProductCategories.indexOf(this.id);
    if (index > -1) {
      window.filtersListProductCategories.splice(index, 1);
    } else {
      window.filtersListProductCategories = window.filtersListProductCategories.filter(function (value, index, array) {
        return window.filtersListProductCategories.indexOf(value) == index;
      });
    }

  } else {
    $(this).find('.arrow').addClass('arrowDown');

    window.filtersListProductCategories.push(this.id);
  }

  sessionStorage.setItem('collapse', JSON.stringify(window.filtersListProductCategories));
});

$('#download-items li').on('click', function () {
  if ($(this).is('.collapsed')) {
    $(this).find('.icon-more').css('backgroundImage', 'url(/images/icons/download_menos.png)');
  } else {
    $(this).find('.icon-more').css('backgroundImage', 'url(/images/icons/download_mais.png)');
  }
});
